(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── 1. Hero load animation ────────────────────────────── */
  var hero = document.querySelector('.fuse-holding');
  if (hero) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        hero.classList.add('is-loaded');
      });
    });

    var productImg = hero.querySelector('.fuse-holding__hero-product-img');
    if (productImg) {
      var revealProduct = function () {
        requestAnimationFrame(function () {
          productImg.classList.add('is-img-loaded');
        });
      };
      if (productImg.complete && productImg.naturalWidth > 0) {
        revealProduct();
      } else {
        productImg.addEventListener('load', revealProduct, { once: true });
        productImg.addEventListener('error', revealProduct, { once: true });
      }
    }
  }

  /* ── 2. Scroll-reveal via IntersectionObserver ─────────── */
  var reveals = document.querySelectorAll('[data-fuse-reveal]');
  if (!reveals.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  reveals.forEach(function (el) {
    observer.observe(el);
  });

  /* ── 3. Lightweight parallax on scroll ─────────────────── */
  var parallaxContainers = document.querySelectorAll('[data-fuse-parallax]');
  if (!parallaxContainers.length) return;

  var ticking = false;

  function updateParallax() {
    var vh = window.innerHeight;
    parallaxContainers.forEach(function (container) {
      var rect = container.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var progress = (vh - rect.top) / (vh + rect.height);
      var shift = (progress - 0.5) * 30;
      var target =
        container.querySelector('.fuse-waitlist__bg-img') ||
        container.querySelector('.fuse-replace-routine__bg') ||
        container.querySelector('.fuse-clean-energy__bg-img');
      if (target) {
        target.style.transform = 'translateY(' + shift + 'px) scale(1.04)';
      }
    });
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    },
    { passive: true }
  );
})();
